"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactDataForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
const SingleContactDataForm_1 = require("./SingleContactDataForm");
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactDataForm = class ContactDataForm extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.newContactDataContent = { title: '', description: '' };
    }
    get canDisplay() {
        return this.content.tabs.contactData.canDisplay;
    }
    set canDisplay(value) {
        this.content.tabs.contactData.canDisplay = value;
    }
    /**
     * Add new contactData card
     */
    addNewContactDataContent() {
        const listCopy = [...this.content.tabs.contactData.content];
        listCopy.push(JSON.parse(JSON.stringify(this.newContactDataContent)));
        this.content.tabs.contactData.content = listCopy;
    }
    /**
     * Removes contactData by ID
     * @param data
     */
    deleteContactData(data) {
        const itemToDelete = this.content.tabs.contactData.content.indexOf(data);
        const listCopy = [...this.content.tabs.contactData.content];
        listCopy.splice(itemToDelete, 1);
        this.content.tabs.contactData.content = listCopy;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true, default: {} }),
    __metadata("design:type", Object)
], ContactDataForm.prototype, "content", void 0);
ContactDataForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'ContactDataForm',
        components: {
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            SingleContactDataForm: SingleContactDataForm_1.SingleContactDataForm
        },
        template: `
    <div class="container" @click.stop>
      <div class="row px-3 pt-3 w-100">
        <DashmixCheck class="pb-2" :label="$t('forms.contact.tabs.'+content.tabs.contactData.id+'.canDisplay')" name="contactdata"
                      :model.sync="canDisplay" />
      </div>
        <div class="row px-2 my-1 w-100">
          <div v-for="(data, index) in content.tabs.contactData.content" :key="index" class="d-flex mx-2 my-2 flex-row align-items-center figure-with-btn__image-container">
            <SingleContactDataForm :contact-data="content.tabs.contactData.content[index]"/>
            <DashmixButton variant="icon" class="figure-with-btn__delete-btn" :icon="icons.TrashSolid" theme="danger" @click="() => deleteContactData(data)" />
          </div>
         <DashmixButton variant="icon" :icon="icons.PlusSolid" theme="primary" @click="addNewContactDataContent" />
      </div>
    </div>
  `
    })
], ContactDataForm);
exports.ContactDataForm = ContactDataForm;
//# sourceMappingURL=ContactDataForm.js.map